export const CONNECT_OPENSEA = 'CONNECT_OPENSEA';
